import styled from '@emotion/styled';
export const GamingWidgetImageWrapper = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const GamingWidgetStyledImage = styled.img `
  width: 90%;
  min-width: 50px;
  height: 90%;
  object-fit: contain;
`;
